import React, { useState, useEffect } from 'react';
import { Form, Select, Tabs, Row, Col, Input, notification } from 'antd';
import CreateProviderPermalink from 'utils/data/CreateProviderPermalink';
import PropTypes from 'prop-types';
import CreateBasicFlightForm from '../CreateBasicFlightForm/CreateBasicFlightForm';
import generatePermalink from '../../utils/data/CreateFlightHotelPayload';
import SavedOfferTable from '../SavedOffersTable/SavedOffersTable';
import './BasicFlightForm.less';

const { TabPane } = Tabs;

const messages = {
  success: (value, iata) => `Listo! Se clonaron ${value} fechas al IATA ( ${iata} ) 🛫`,
  warning: (value, iata) => `Ojo! Hubo un error al clonar con ${value} fechas al IATA ( ${iata} ), dales una checada antes de guardar porfavor 🙏 `,
  error: (value, iata) => `Oh no! No se pudieron generar +85% de las fechas del IATA ( ${iata} ), refrescamos la pagina e intentamos otra vez? 🛸`,
};
const openNotificationWithIcon = ({ type, value, iata }) => {
  notification[type]({
    message: 'Clonando las fechas',
    description: messages[type](value, iata),
    duration: type === 'success' ? 5 : 0,
  });
};

/**
 * Basic Flight Form:
 * This form is for the BasicFlight data. This includes the
 * tab creation (iatas), flight data recollection (return date, cost, url)
 * and a table where you can see, expire, delete and edit a single flight
 *
 * @author Israel García
 */
const BasicFlight = (props) => {
  const { flightHotel, hotelPost, form, handleRequest, isRound, savedFlights, savedIatas, savedProviders, token } = props;

  const { getFieldDecorator, getFieldValue, resetFields, setFieldsValue } = form;

  const [counterToEdit, setcounterToEdit] = useState(false);
  const [currentFlights, setCurrentFlights] = useState([]);
  const [currentIata, setcurrentIata] = useState(null);
  const [flightToEdit, setFlightToEdit] = useState({});
  const [iatas, setIatas] = useState([]);
  const [lowestPrice, setLowestPrice] = useState(null);
  const [providers, setProviders] = useState([]);

  const [dragAndDrop, setDragAndDrop] = useState({
    draggedFrom: null,
    draggedTo: null,
    isDragging: false,
    originalOrder: [],
    updatedOrder: [],
  });

  const onDragStart = (event) => {
    const initialPosition = Number(event.currentTarget.dataset.position);
    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: initialPosition,
      isDragging: true,
      originalOrder: iatas,
    });
    // Note: this is only for Firefox.
    // Without it, the DnD won't work.
    // But we are not using it.
    event.dataTransfer.setData('text/html', '');
  };

  const onDragOver = (event) => {
    // in order for the onDrop
    // event to fire, we have
    // to cancel out this one
    event.preventDefault();

    let newList = dragAndDrop.originalOrder;

    // index of the item being dragged
    const { draggedFrom } = dragAndDrop;

    // index of the droppable area being hovered
    const draggedTo = Number(event.currentTarget.dataset.position);

    const itemDragged = newList[draggedFrom];
    const remainingItems = newList.filter((item, index) => index !== draggedFrom);

    newList = [...remainingItems.slice(0, draggedTo), itemDragged, ...remainingItems.slice(draggedTo)];

    if (draggedTo !== dragAndDrop.draggedTo) {
      setDragAndDrop({
        ...dragAndDrop,
        updatedOrder: newList,
        draggedTo,
      });
    }
  };

  const onDrop = () => {
    setIatas(dragAndDrop.updatedOrder);
    setDragAndDrop({
      ...dragAndDrop,
      draggedFrom: null,
      draggedTo: null,
      isDragging: false,
    });
  };

  const onDragLeave = () => {
    setDragAndDrop({
      ...dragAndDrop,
      draggedTo: null,
    });
  };

  /**
   * Method that cleans currentFlight to keep just desired iatas
   * @param {array} iataList List of all iatas that should be listed
   */
  const setCleanIatas = (iataList) => {
    const updatedFlights = {};
    iataList.forEach((iata) => {
      updatedFlights[iata] = currentFlights[iata] || [];
    });
    setCurrentFlights({
      ...updatedFlights,
    });
  };

  /**
   * Method that handles the change on the select input (iatas origen)
   * and set the iatas
   * @param {array} value
   */
  const handleChange = (value) => {
    setIatas(value.map((iata) => iata.toUpperCase()));
    setCleanIatas(value.map((iata) => iata.toUpperCase()));
  };

  /**
   * Method that handles when we need to delete a iata from out list.
   * First it validates if we are trying to delete the current iata, then
   * we delete it
   * @param {String} value
   */
  const handleDeselect = (value) => {
    // TODO: Validate the override behavior of the Select input once the entry is duplicated
    if (currentIata === value) {
      setcurrentIata(iatas.filter((e) => e !== value)[0]);
    }
    setCurrentFlights({
      ...currentFlights,
      [value]: [],
    });
    setFlightToEdit('');
    setIatas(iatas.filter((e) => e !== value));
  };

  const parseIatasMonthsAndLowestPrice = (flights) => {
    const destinations = {};
    const departures = {};
    const parsedMonths = {};
    const providerObj = {
      newLowestPrice: 999999,
      newLowestPriceUrl: '',
    };
    Object.keys(flights).map((key) => {
      flights[key].map((v) => {
        if (!destinations[v.arrival_iata]) destinations[v.arrival_iata] = 1;
        else destinations[v.arrival_iata] += 1;

        if (!departures[v.departure_iata]) departures[v.departure_iata] = 1;
        else departures[v.departure_iata] += 1;

        if (!parsedMonths[v.departure_date.month() + 1]) {
          parsedMonths[v.departure_date.month() + 1] = 1;
        } else parsedMonths[v.departure_date.month() + 1] += 1;
        if (v.price < providerObj.newLowestPrice) {
          providerObj.newLowestPrice = v.price;
          providerObj.newLowestPriceUrl = v.provider_permalink;
        }
        return v;
      });
      return key;
    });

    return {
      destinations,
      departures,
      parsedMonths,
      providerObj,
    };
  };

  /**
   *UseEffect for our iatas
   */
  useEffect(() => {
    if (iatas.length > 0 && !currentIata) setcurrentIata(iatas[0]);
  }, [iatas, currentIata]);

  /**
   * Load flights when received from DB
   * savedFlights just loads once the query is resolved and data was parsed
   * This method mainly loads full state when editing an existing file
   * OR keeps it updated when working in a new one
   */
  useEffect(() => {
    if (savedFlights && Object.keys(savedFlights).length) {
      setCurrentFlights({
        ...savedFlights,
      });
      setcurrentIata(savedFlights[0]);
      setIatas(savedIatas);
      setProviders(savedProviders);
      setFieldsValue({
        destination: savedFlights[savedIatas[0]][0].arrival_iata,
        origin: savedIatas,
      });
    } else if (getFieldValue('origin')) {
      resetFields();
      setIatas([]);
      setCurrentFlights({});
    }
  }, [savedFlights]);

  /**
   * Method that is fired when our primary form is submited
   * In here we send the validated data to our FormContainer, see
   * our spect for further information
   */
  useEffect(() => {
    const { destinations, parsedMonths, providerObj } = parseIatasMonthsAndLowestPrice(currentFlights);
    handleRequest({
      providers,
      lowest_price: providerObj.newLowestPrice,
      provider_permalink: providerObj.newLowestPriceUrl,
      flights: currentFlights,
      destinations_iatas: Object.keys(destinations),
      departures_iatas: iatas, // Object.keys(departures),
      months: Object.keys(parsedMonths),
    });
  }, [currentFlights, iatas]);

  /**
   *
   * Method that receives an array of flights and sorts them by `departure_date` value
   * @param {Array} flights Flights to be sorted
   */
  const sortFlightsByDate = (flights) => flights.slice().sort((a, b) => a.departure_date - b.departure_date);

  /**
   * Method to sort the comment and then by date
   * @param {Array} flights Flights to be sorted
   */
  const sortFlightsByComment = (flights) => flights.slice().sort((a, b) => a.comment.localeCompare(b.comment) || a.departure_date - b.departure_date);

  /**
   * Method to handler the flight sorts
   * @param {Array} flights Flights to be sorted
   */
  const sortFlightsHandler = (flights) => {
    if (flights[0].comment) {
      return sortFlightsByComment(flights);
    }
    return sortFlightsByDate(flights);
  };

  /**
   *
   * This method receives a validated Flight JSON and then is added
   * to out currentFlights state under the current iata key
   *
   * This method is sent as prop to our 'child' form
   * If the editable is true, we update the currentFlight with the actual flight param
   * @param flight
   * @param editable
   */
  const handleFlightSubmit = (flight, editable = false) => {
    if (providers.indexOf(flight.provider) === -1) {
      setProviders([...providers, flight.provider]); // TODO: Validate when a iata is deleted?
    }
    if (!lowestPrice || flight.price < lowestPrice) {
      setLowestPrice(flight.price); // TODO: Validate when a iata is gone, we might map every flight
    }
    if (editable) {
      const cloneCurrentFlights = {
        ...currentFlights,
      };
      cloneCurrentFlights[currentIata][flightToEdit.index] = flight;
      cloneCurrentFlights[currentIata] = sortFlightsHandler(cloneCurrentFlights[currentIata]);
      setFlightToEdit('');
      setCurrentFlights(cloneCurrentFlights);
    } else if (!currentFlights[currentIata]) {
      setCurrentFlights({
        ...currentFlights,
        [currentIata]: [flight],
      });
    } else {
      const sortedFlights = sortFlightsHandler([...currentFlights[currentIata], flight]);
      setCurrentFlights({
        ...currentFlights,
        [currentIata]: sortedFlights,
      });
    }
  };

  /**
   * This method removes selected flight from table
   * @param {*} toDelete // array of indexes to be removed
   */
  const deleteFlight = (toDelete) => {
    const newFlights = currentFlights;
    newFlights[currentIata] = currentFlights[currentIata].filter((_, i) => !toDelete.includes(i));
    setCurrentFlights({
      ...newFlights,
    });
  };

  /**
   * Method to edit the selected flight
   * @param rowIndex
   */
  const editFlight = (rowIndex) => {
    document.querySelector('#basicFlightForm_origin').scrollIntoView({
      behavior: 'smooth',
    });
    console.log('B: BasicFLightForm:', currentFlights[currentIata][rowIndex]);
    setFlightToEdit({
      flight: currentFlights[currentIata][rowIndex],
      index: rowIndex,
    });
    setcounterToEdit(!counterToEdit);
  };

  /**
   * Method that expires a list of received flights
   * @param {*} indexesToExpire // array of indexes to expire
   */
  const expireFlight = (indexesToExpire) => {
    // TODO - Fix this 'toggle' work around.
    // We should handle in a better way the 'expire' status
    const flightsUpdated = currentFlights;
    flightsUpdated[currentIata] = currentFlights[currentIata].map((flightInfo, i) => {
      const currentFlight = flightInfo;
      if (indexesToExpire.includes(i)) {
        currentFlight.expired = !currentFlight.expired;
      }
      return currentFlight;
    });
    setCurrentFlights({
      ...flightsUpdated,
    });
  };

  /**
   * Method that clones a list of received flights
   * @param {array} indexesToClone Array of flight indexes to clone
   * @param {array} newDepartureIatas Array of iatas INDEXES where selected flights will be cloned
   */
  const cloneFlight = (indexesToClone, newDepartureIatas) => {
    const flightsUpdated = {
      ...currentFlights,
    };
    const clonedFlights = currentFlights[currentIata].filter((_, i) => indexesToClone.includes(i));
    const originId = [];

    // Get an object with all unresolved permalink promises
    const newPermalinkPromises = {};
    newDepartureIatas.forEach((iata) => {
      const newIata = iatas[iata];
      if (flightHotel) {
        const destination = hotelPost ? '-' : form.getFieldValue('destination');

        newPermalinkPromises[newIata] = clonedFlights.map((flight) => {
          if (flight.provider === 'bestday' && !Object.keys(originId).includes(newIata)) {
            originId[newIata] = prompt(`Porfavor ingresa el Origin ID de ${newIata}:`, 'XXXX');
          }
          const payload = {
            ...flight,
            origin_id: originId[newIata] !== '' ? originId[newIata] : flight.origin_id,
            destination,
            isRound,
            iataId: newIata,
            token,
          };
          return generatePermalink(payload);
        });
      } else {
        newPermalinkPromises[newIata] = clonedFlights.map((flight) => CreateProviderPermalink(flight, newIata, isRound, token));
      }
    });

    // Resolve promises
    Object.keys(newPermalinkPromises).map((iata) =>
      Promise.allSettled(newPermalinkPromises[iata]).then((res) => {
        console.log(res);
        const rejected = [];
        const updatedCloneFlights = clonedFlights.map((flight, index) => {
          const isFulfilled = res[index].status === 'fulfilled';
          const newEntry = {
            ...flight,
            origin_id: originId[iata] !== '' && flightHotel ? originId[iata] : flight.origin_id,
            provider_permalink: isFulfilled ? res[index].value.provider_permalink : '',
            departure_iata: iata,
          };
          if (!isFulfilled) rejected.push(index);
          return newEntry;
        });
        flightsUpdated[iata].push(...updatedCloneFlights);
        flightsUpdated[iata] = sortFlightsHandler(flightsUpdated[iata]);
        if (rejected.length === 0) {
          openNotificationWithIcon({
            type: 'success',
            value: clonedFlights.length,
            iata,
          });
        } else if (rejected.length > 0 && rejected.length <= clonedFlights.length * 0.8) {
          openNotificationWithIcon({
            type: 'warning',
            value: rejected.length,
            iata,
          });
        } else {
          openNotificationWithIcon({
            type: 'error',
            value: rejected.length,
            iata,
          });
        }
        setCurrentFlights({
          ...flightsUpdated,
        });
      }),
    );
  };

  /**
   * This method handles when the tab is changed. Its function is to
   * set the current iata based on the parameter
   * @param {String} activeKey
   */
  const handleTabChange = (activeKey) => {
    setcurrentIata(activeKey);
  };

  /**
   * Method to init on primitive value the edit state
   */
  const handleResetForm = () => {
    setFlightToEdit('');
  };

  const renderBasicFlightForm = () => (
    <>
      <Form>
        <Row gutter={20}>
          <Col>
            <h2 className="form-title">Sobre el Vuelo</h2>
          </Col>
          <Col span={16}>
            <Form.Item label="Ciudades de Origen">
              {getFieldDecorator('origin', {
                rules: [
                  {
                    required: true,
                    message: 'Por favor agrega un(os) Iata(s)',
                  },
                ],
              })(
                <Select
                  mode="tags"
                  placeholder="IATAS de Origen"
                  className="origen-input"
                  onChange={handleChange}
                  onBlur={handleChange}
                  onDeselect={handleDeselect}
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Ciudad de Destino">
              {getFieldDecorator('destination', {
                getValueFromEvent: (e) => e.target.value.toUpperCase(),
                rules: [
                  {
                    required: true,
                    message: 'Por favor agregue un Destino (iata)',
                  },
                ],
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row gutter={20}>
        <h4>Orden de Destinos</h4>
        <ul>
          {iatas.map((item, index) => {
            const isDropArea = dragAndDrop && dragAndDrop.draggedTo === Number(index) ? 'dropArea' : '';
            return (
              <li
                key={item}
                data-position={index}
                draggable
                onDragStart={onDragStart}
                onDragOver={onDragOver}
                onDrop={onDrop}
                onDragLeave={onDragLeave}
                className={`iataElement ${isDropArea}`}
              >
                {`${index + 1} - ${item}`}
              </li>
            );
          })}
        </ul>
      </Row>
    </>
  );

  const renderHotelPostForm = () => (
    <>
      <Form>
        <Row gutter={20}>
          <Col>
            <h2 className="form-title">Sobre el Hospedaje</h2>
          </Col>
          <Col span={16}>
            <Form.Item label="Habitacion">
              {getFieldDecorator('origin', {
                rules: [
                  {
                    required: true,
                    message: 'Por favor agregael Tipo de Habitacion (Sencilla, Doble)',
                  },
                ],
              })(
                <Select
                  mode="tags"
                  placeholder="Tipo de Hab"
                  className="origen-input"
                  onChange={handleChange}
                  onBlur={handleChange}
                  onDeselect={handleDeselect}
                />,
              )}
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );

  return (
    <div className="basic-flight-form">
      {!hotelPost && renderBasicFlightForm()}
      {hotelPost && renderHotelPostForm()}
      <Row gutter={20}>
        <Col>
          <Tabs defaultActiveKey="1" tabPosition="top" onChange={handleTabChange}>
            {iatas.map((i) => (
              <TabPane tab={`${i} ${currentFlights[i] ? `(${currentFlights[i].length})` : '(0)'}`} key={i}>
                <CreateBasicFlightForm
                  counterToEdit={counterToEdit}
                  destination={hotelPost ? '-' : form.getFieldValue('destination')}
                  editableFlight={flightToEdit}
                  handleRequest={handleFlightSubmit}
                  handleResetForm={handleResetForm}
                  iataId={i}
                  isFlightHotel={flightHotel}
                  isRound={isRound}
                  token={token}
                />
              </TabPane>
            ))}
          </Tabs>
        </Col>
      </Row>
      <Row gutter={20}>
        <SavedOfferTable
          cloneFlight={cloneFlight}
          currentFlights={currentFlights[currentIata]}
          currentIata={currentIata}
          deleteFlight={deleteFlight}
          editFlight={editFlight}
          expireFlight={expireFlight}
          iataList={iatas}
          isRound={isRound}
        />
      </Row>
    </div>
  );
};

BasicFlight.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.object.isRequired,
  handleRequest: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
  flightHotel: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  savedFlights: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  savedIatas: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  savedProviders: PropTypes.array.isRequired,
  isRound: PropTypes.bool,
  hotelPost: PropTypes.bool,
};

BasicFlight.defaultProps = {
  flightHotel: false,
  hotelPost: false,
  isRound: false,
};

const BasicFlightForm = Form.create({
  name: 'basicFlightForm',
})(BasicFlight);

export default BasicFlightForm;
